module.exports = __webpack_public_path__ + "img/downloading.d3d6a8b4.svg";